import { createGrupoAtivosHook } from "./createGrupoAtivosHook"

export const useGrupoAtivosCorporateIF = createGrupoAtivosHook()